import { AppTooltip } from '@components'
import type { Setup } from '@here/api'
import { Triangle } from './Triangle'
import { Show } from 'solid-js'
import { Flex } from 'styled-system/jsx'
import SlungBadge from '../../SlungBadge'
import { css } from 'styled-system/css'

export default function (props: { setup?: Setup }) {
	return (
		<Show when={props.setup}>
			<Flex
				gap={2}
				justifyContent="space-between"
				alignItems="center"
			>
				<Flex
					gap={2}
					alignItems="center"
				>
					<SlungBadge patternSpecification={props.setup?.pattern_specification} />
					<Show when={props.setup?.first_in_new_trend || true}>
						<AppTooltip content="potential overperformance">
							<Triangle color="#00A881" />
						</AppTooltip>
					</Show>
					<Show when={props.setup?.has_primer || true}>
						<AppTooltip content="Has Primer">
							<Triangle
								direction="right"
								color="#6F349F"
							/>
						</AppTooltip>
					</Show>
				</Flex>
			</Flex>
		</Show>
	)
}
